var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.theme,attrs:{"id":"app"}},[_vm._m(0),_c('HeaderComponent'),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scrollbar",attrs:{"id":"style-default"}},[_c('div',{staticClass:"force-overflow"})])
}]

export { render, staticRenderFns }